import './LandingPage.css';
import Nav from './sections/Nav';
import Hero from './sections/Hero';
import UseCases from './sections/UseCases';
import ModelShowcase from './sections/ModelShowcase';
import ZenSection from './sections/ZenMockup';
import Pricing from './sections/Pricing';
import ApiSection from './sections/ApiSection';
import SocialProof from './sections/SocialProof';
import FinalCTA from './sections/FinalCTA';
import Footer from './sections/Footer';

// Stats — Phase 4 will replace these with live API calls
const STATS = [
  { v: '50+',   l: 'Models available' },
  { v: '12M+',  l: 'Generations made' },
  { v: '99.9%', l: 'API uptime' },
];

export default function LandingPage() {
  return (
    <div className="uro-landing-root">
      {/* Animated background orbs */}
      <div className="page-orbs" aria-hidden="true">
        <div className="orb orb-a"/>
        <div className="orb orb-b"/>
        <div className="orb orb-c"/>
        <div className="orb orb-d"/>
      </div>

      {/* Film grain overlay */}
      <div className="grain" aria-hidden="true"/>

      {/* Main content */}
      <div className="landing-content">
        <Nav/>
        <main>
          <Hero stats={STATS}/>
          <UseCases/>
          <ModelShowcase/>
          <ZenSection/>
          <Pricing/>
          <ApiSection/>
          <SocialProof/>
          <FinalCTA/>
        </main>
        <Footer/>
      </div>
    </div>
  );
}
